module.exports = __webpack_public_path__ + "static/img/1935_phase_function_Paper_Points.fa390b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1935_phase_function_Paper_Points.png
// module id = LUUE
// module chunks = 0